/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourseDto
 */
export interface CourseDto {
    /**
     * 
     * @type {string}
     * @memberof CourseDto
     */
    courseId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CourseDto
     */
    sequence: number;
}

/**
 * Check if a given object implements the CourseDto interface.
 */
export function instanceOfCourseDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "courseId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "sequence" in value;

    return isInstance;
}

export function CourseDtoFromJSON(json: any): CourseDto {
    return CourseDtoFromJSONTyped(json, false);
}

export function CourseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'courseId': json['courseId'],
        'name': json['name'],
        'sequence': json['sequence'],
    };
}

export function CourseDtoToJSON(value?: CourseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'courseId': value.courseId,
        'name': value.name,
        'sequence': value.sequence,
    };
}

